exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_sharePointSiteCard_VfDtCCny91sINheGd5xpv{\n  display:flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.IA_sharePointSiteWrapper_1TkqTM2ymnrPR6Gb3l2f-h {\n  font-size: 14px;\n  float: left;\n  display: block;\n  width: 100%;\n  padding: 8px 0;\n}\n\n.IA_sharePointSiteId_1jq2h2xeSSX-aCC4z0j7hG {\n  font-size: 9px;\n  opacity: 0.8\n}", ""]);

// Exports
exports.locals = {
	"IA_sharePointSiteCard": "IA_sharePointSiteCard_VfDtCCny91sINheGd5xpv",
	"IA_sharePointSiteWrapper": "IA_sharePointSiteWrapper_1TkqTM2ymnrPR6Gb3l2f-h",
	"IA_sharePointSiteId": "IA_sharePointSiteId_1jq2h2xeSSX-aCC4z0j7hG"
};